import { render, staticRenderFns } from "./VolumeTrends.vue?vue&type=template&id=57bdc87f&scoped=true"
import script from "./VolumeTrends.vue?vue&type=script&lang=js"
export * from "./VolumeTrends.vue?vue&type=script&lang=js"
import style0 from "./VolumeTrends.vue?vue&type=style&index=0&id=57bdc87f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bdc87f",
  null
  
)

export default component.exports